// 2021-06-20 C0125 Add this for config base url for axio

let baseURL = 'https://api.pgebet.com/' // 核心业务请求API
let service2URL = 'https://api.pgebet.com/' // 非核心业务请求API
let version = '4.3.135'
let apkVersion = '1.5.9'
let agentWebsite
switch (location.hostname) {
  case '192.168.0.153':
    baseURL = 'https://uat-api.pgebet.com/'
    service2URL = baseURL
    agentWebsite = baseURL
    break
  case 'localhost':
    baseURL = 'https://uat-api.pgebet.com/'
    service2URL = baseURL
    agentWebsite = baseURL
    break
  case 'test.pgebet.com':
    baseURL = 'https://uat-api.pgebet.com/'
    service2URL = baseURL
    agentWebsite = baseURL
    break
  case 'app.pgebet.com':
    baseURL = 'https://api.pgebet.com/'
    service2URL = 'https://log-api.pgebet.com/'
    agentWebsite = 'https://agent.pgebet.com'
    break
  case 'app.pgebet01.com':
    baseURL = 'https://api.pgebet01.com/'
    service2URL = 'https://log-api.pgebet01.com/'
    agentWebsite = 'https://agent.pgebet01.com'
    break
  case 'app.pge01.com':
    baseURL = 'https://api.pge01.com/'
    service2URL = 'https://log-api.pge01.com/'
    agentWebsite = 'https://agent.pge01.com'
    break
  case 'app.pgebet.xyz':
    baseURL = 'https://api.pgebet.xyz/'
    service2URL = 'https://log-api.pgebet.xyz/'
    agentWebsite = 'https://agent.pgebet.xyz'
    break
  case 'app.pgebet.cc':
    baseURL = 'https://api.pgebet.cc/'
    service2URL = 'https://log-api.pgebet.cc/'
    agentWebsite = 'https://agent.pgebet.cc'
    break
  case 'app.pgebet.top':
    baseURL = 'https://api.pgebet.top/'
    service2URL = 'https://log-api.pgebet.top/'
    agentWebsite = 'https://agent.pgebet.top'
    break
  case 'app.pgebet.org':
    baseURL = 'https://api.pgebet.org/'
    service2URL = 'https://log-api.pgebet.org/'
    agentWebsite = 'https://agent.pgebet.org'
    break
  case 'app.pgebet.app':
    baseURL = 'https://api.pgebet.app/'
    service2URL = 'https://log-api.pgebet.app/'
    agentWebsite = 'https://agent.pgebet.app'
    break
  case 'app.pgebet.club':
    baseURL = 'https://api.pgebet.club/'
    service2URL = 'https://log-api.pgebet.club/'
    agentWebsite = 'https://agent.pgebet.club'
    break
  case 'app.pgebet.net':
    baseURL = 'https://api.pgebet.net/'
    service2URL = 'https://log-api.pgebet.net/'
    agentWebsite = 'https://agent.pgebet.net'
    break
  case '25csf.betajay.net':
    baseURL = 'https://uat-api.pgebet.com/'
    service2URL = 'https://uat-api.pgebet.com/'
    agentWebsite = 'https://uat-agent.pgebet.com'
    break
  case '25test.betajay.net':
    baseURL = 'https://uat-api.pgebet.com/'
    service2URL = 'https://uat-api.pgebet.com/'
    agentWebsite = 'https://uat-agent.pgebet.com'
    break
  case 'test-app.pgebet.com':
    baseURL = 'https://test-api1.pgebet.com/'
    service2URL = 'https://test-api1.pgebet.com/'
    agentWebsite = 'https://test-agent.pgebet.com'
    break
  case 'pre-app.pgebet.com':
    baseURL = 'https://pre-api.pgebet.com/'
    service2URL = 'https://pre-api.pgebet.com/'
    agentWebsite = 'https://pre-api.pgebet.com'
    break
  case 'pre-app.betajay.com':
    baseURL = 'https://pre-api.betajay.com/'
    service2URL = 'https://pre-api.betajay.com/'
    agentWebsite = 'https://pre-api.betajay.com'
    break
}
service2URL = baseURL

// 根据环境不同导出不同的baseURL
let config = {
  baseURL: baseURL,
  version: version,
  apkVersion: apkVersion,
  service2URL: service2URL,
  logPath: ['Landing1', 'Landing2', 'Landing3', 'Landing4', 'Home'],
  agentWebsite
}
export default config



//////////////////
// WEBPACK FOOTER
// ./static/config/config.js
// module id = D08P
// module chunks = 0